import templateUrl from '../templates/table-options.tpl.html';

class TableOptionsCtrl {
    constructor(store, $uibModalInstance, $scope, $filter) {
        this.store = store;
        this.modal = $uibModalInstance;
        this.scope = $scope;
        this.filter = $filter;
        this.columns = _.cloneDeep(this.store.state.columns)
            .filter((col) => {
                return !col.hidden;
            });

        this.columnsGrouped = {};
        this.visible = null;
        this.colFilter = '';
        this.searchActive = false;

        this.enabledFields = [];

        this._prepareColumnGroups();
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.visible;
        }, () => {
            this._prepareColumnGroups();
        });

        this.scope.$watch(() => {
            return this.colFilter;
        }, () => {
            this._prepareColumnGroups();
        });
    }

    _prepareColumnGroups() {
        this.columnsGrouped = {};

        _.each(this.filter('filter')(this.columns, this._getCurrentColFilters()), (col) => {
            if (!this.columnsGrouped[col.group]) {
                this.columnsGrouped[col.group] = {
                    label: col.group,
                    columns: [],
                    shown: false
                }
            }

            this.columnsGrouped[col.group].columns.push(col);
        });

        this.columnsGrouped = _.sortBy(this.columnsGrouped, 'label')
            .map((row) => {
                row.columns = _.sortBy(row.columns, 'label');
                return row;
            });
    }

    _getCurrentColFilters() {
        const out = {
            label: this.colFilter
        };

        if (this.visible !== null) {
            out.visible = this.visible;
        }

        this.searchActive = !!(this.colFilter || (this.visible !== null));

        return out;
    }

    close() {
        this.modal.dismiss();
    }

    reset() {
        this.modal.dismiss();
        const filters = this.store.state.permanentFilters;
        const prefix = this.store.state.prefix;

        this.store.dispatch('resetState');
        this.store.commit('setPermanentFilters', filters);
        this.store.commit('setPrefix', prefix);
    }

    save() {
        this.modal.close({columns: this.columns});
    }

}

TableOptionsCtrl.$inject = [
    'store',
    '$uibModalInstance',
    '$scope',
    '$filter'
];

class TableOptionsControllerV2 {
    constructor(store, $uibModalInstance) {
        this.store = store;
        this.modalInstance = $uibModalInstance;

        this.customFieldDefinitions = {
            availability: {
                contact: false,
                rsvp: false
            },
            definitions: {
                contact: {},
                rsvp: {}
            }
        };

        this._prepareAvailableFields();
        this._prepareCurrentDefinition();
    }

    close() {
        this.modalInstance.dismiss();
    }

    reset() {
        this.modalInstance.dismiss();
        const filters = this.store.state.permanentFilters;
        const prefix = this.store.state.prefix;

        this.store.dispatch('resetState');
        this.store.commit('setPermanentFilters', filters);
        this.store.commit('setPrefix', prefix);
    }

    save() {
        this.modalInstance.close({visibleColumns: this._prepareColumnsForResponse()});
    }

    updateSelectedFields(newDefinition) {
        this.currentDefinition = newDefinition;
    }

    _prepareColumnsForResponse() {
        return _.map(_.cloneDeep(this.currentDefinition), (row) => {
            return row.slug;
        });
    }

    _prepareAvailableFields() {
        this.availableFields = {};
        this.enabledFields = [];

        _.each(_.filter(_.cloneDeep(this.store.state.columns), (col) => {
            return !col.hidden;
        }), (column) => {
            this.availableFields[column.key] = {
                default_label: column.label,
                group: column.group,
                groupLabelOverride: column.group
            }
        });
    }

    _prepareCurrentDefinition() {
        const visibleFieldKeys = this.store.state.visible;
        this.currentDefinition = _.filter(_.cloneDeep(this.store.state.columns), (column) => {
            return !column.hidden && column.visible;
        }).map((col) => {
            return {
                slug: col.key
            };
        }).sort(function (a, b) {
            return visibleFieldKeys.indexOf(a.slug) - visibleFieldKeys.indexOf(b.slug);
        });
    }
}

TableOptionsControllerV2.$inject = [
    'store',
    '$uibModalInstance'
];

export default (store) => {
    const $uibModal = store.ng.injector.get('$uibModal');

    const modalInstance = $uibModal.open({
        templateUrl: templateUrl,
        controller: TableOptionsControllerV2,
        controllerAs: 'vm',
        backdrop: 'static',
        size: 'xlg',
        resolve: {
            store() {
                return store;
            }
        }
    });

    return modalInstance.result.then(result => {
        const visibleColumns = result.visibleColumns;
        store.commit('setColumns', _.map(store.state.columns, (col) => {
            return {
                ...col,
                visible: visibleColumns.indexOf(col.key) !== -1
            };
        }));
        store.commit('setVisible', visibleColumns);
        store.dispatch('saveState');
        store.dispatch('getData');
    }, () => {
    });
}



// WEBPACK FOOTER //
// ./src/app/store/base/actions/table-options.js